import { Component, ViewChild, ChangeDetectorRef, Input, ElementRef, ViewChildren, QueryList, Output, EventEmitter, Inject } from '@angular/core';
import {  MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MatList,  MatListItem } from '@angular/material/list';
import { BehaviorSubject, timer } from 'rxjs';
// import { Subscription } from 'src/app/model/subscription';
// import { MeasurementService } from 'src/app/services/measurementService';
// import { State } from 'src/app/services/state';
// import { StateService } from 'src/app/services/stateService';
// import { isoString } from 'src/app/utils/dateUtils';
import { EvidenceWidget } from '../logging/evidence-widget/evidence-widget';
import { NumberKeyboard } from '../number-keyboard/numberKeyboard';
import {ScoredSubscription, CommonService, MiniTracker,MiniWrapper, LogMeasurement, GetGuidanceSubs, MiniTrackerUtil} from 'huddyapi';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngxs/store';



@Component({
    selector: 'logging-detail-dialog',
    templateUrl: 'logging-detail-dialog.html',
    styleUrls: ['./logging-detail-dialog.scss'],
    providers: []
})
export class LoggingDetailDialog {

  @ViewChildren(MatListItem,  { read: ElementRef }) listItems!: QueryList<ElementRef>;
  @ViewChildren(EvidenceWidget) evidenceWidgets!: QueryList<EvidenceWidget>;
  @ViewChild(MatList, { read: ElementRef}) itemList : ElementRef;
  
  activeId : number;
  me : LoggingDetailDialog;
  clearLoggingSubject$ = new BehaviorSubject<boolean>(false);
  anyExpanded : boolean = false;
  saving : boolean;
  subscription : ScoredSubscription;

  static SCROLL_BUFFER = 145;

  constructor(
    public dialogRef: MatDialogRef<LoggingDetailDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private common : CommonService,
    public store : Store
  ) {
    this.me = this;
    this.subscription = data.subscription;
  }

  getCompassId() {
    return 'cmps' + encodeURI(''+this.subscription.guidanceSubscriptionId);
  }

  getTrackables(subscription : ScoredSubscription) {
    let ret : MiniTracker[] = [];
    if (subscription.trackables) {
      ret = subscription.trackables;
      if (!this.anyExpanded && ret.length > 0) {
        ret[0].showDetail = true;
        this.anyExpanded = true;
      }
    }
    return ret;
  }

  submitLog() {
    console.log('entering submitLog', this.subscription.trackables);
    if (this.saving) {
      return;
    }
    this.saving = true;
    let measurements : MiniWrapper[] = [];
    let date = new Date();
        // date.setDate(date.getDate()-1);
        // console.log(date);
    for (let t of this.subscription.trackables) {
      if(t.currentVal != null) {
        
        let mt : MiniTracker = new MiniTracker({
          diastolic: undefined,
          systolic: undefined,
          checklist: (t.trackableType == "SYMPTOM" ? "How I Feel" : "Miscellaneous"),
          id: t.id,
          measurementDate: date.toISOString(),
          username: this.subscription.subjectUsername,
          status: 'ACTIVE',
          logState: 'CONFIRMED',
          loggingUser: CommonService.currentUserToView, 
          replace: (t.trackableType == "SYMPTOM" || t.trackableType == "EVIDENCE") ? 'true' : 'false'
        });
        let mw : MiniWrapper = new MiniWrapper(mt, t.name);
    
        if (t.systolic){
            mt.systolic = t.systolic;
            mt.diastolic = t.diastolic;
           MiniTrackerUtil.setBloodPressureRating(mw);
        } else if (t.trackableType === 'TREATMENT') {
           mw.formVal = t.currentVal ? 1 : 0;
        } else {
            mw.formVal = t.currentVal;
        }
        measurements.push(mw);
        

      }
    }
    let action : LogMeasurement = new LogMeasurement(measurements, date.toISOString(), []);
    console.log(action);
    this.store.dispatch(action).subscribe(response => {
      timer(500).subscribe(t => {
        this.close();
        this.saving = false;
      });

    });
  }

  close() {
    this.dialogRef.close();
  }

  getGuidanceSubs() {
    let action = this.data.familyId ? new GetGuidanceSubs(true, false, undefined, this.data.familyId)
      :new GetGuidanceSubs(true, false, this.data.patientId);
    
    console.log('Firing get guidance subs', action);
    this.store.dispatch(action);
  }


  getDateForTrackable(t : MiniTracker) {

  }

  getYesterdayValue(id : number) {

  }



  ngOnChanges() {
  }

  expandTrackable(t: MiniTracker) {
   console.log( 'LoggingDetail','expandMini', t);
    if(t.showDetail) {
        this.activeId = null;
        t.showDetail = false;
      //  this.keyboard.hide();
    }
    else {
        this.activeId = t.id;
        if(t.trackableType == 'SYMPTOM' ) { //|| t.label.toLowerCase() == 'blood pressure') {
            //this.keyboard.hide();
        }
        //this.scrollAfterUpdate(mT.getId());
        t.showDetail = true;
    }
  }

  setTrackable(data: MiniTracker, advance : boolean = true) {
    console.log( 'LoggingDetail','LOGGING: entering setTrackable', advance);

    let next: MiniTracker = null;

    let compassSymptoms : MiniTracker[] = this.getTrackables(this.subscription );
    let index = compassSymptoms.indexOf(data);
    // if (this.isNotableChange(data)) {
    //   advance = false;
    // }
    

    if (advance) {
        if(next) {
            console.log( 'LoggingDetail','LOGGING: got next', next);
            // this.scrollAfterUpdate(data.id, next.id);

            
            let bottomSheetContainer = this.itemList.nativeElement.parentNode;
            for (let e of this.listItems) {
              if (e.nativeElement.id === 'tId' + next.id) {
                bottomSheetContainer.scrollTop = e.nativeElement.offsetTop - LoggingDetailDialog.SCROLL_BUFFER;
                console.log('found element', next, e,  bottomSheetContainer.scrollTop, e.nativeElement.offsetTop );
                break;
              }
            }

            if(next.trackableType != 'EVIDENCE' || next.name.toLowerCase() == 'blood pressure' || next.metric === 'BOOLEAN') {
                this.activeId = null;

            } else {
              console.log('should focus widget');
                this.activeId = next.id;
                let wgt : EvidenceWidget = this.evidenceWidgets.find(wgt => wgt.data.id === this.activeId);
                if (wgt) {
                  wgt.focus();
                }

            }

        }
    }
 }
 
  // scrollAfterUpdate(toId: number, observeId = toId) {
  //   console.log('LoggingDetail', 'scrollAfterUpdate', toId, observeId);
  //     const observer = new MutationObserver((changes) => {
  //       console.log( 'LoggingDetails', 'scrollAfterUpdate', changes);
  //         observer.disconnect();
  //         this.scrollToTrackable(observeId);
  //     });
  //     let elem = this.getExpanderButton('expander-button' + observeId);
  //     if(!elem)
  //         return;
  //     observer.observe(elem.nativeElement, {
  //         childList: true
  //     });
  //     console.log( 'LoggingDetail', 'scrollAfterUpdate', 'exit', observer);
  //   }


}

